export function toFormData<T extends Record<string, string | number | boolean | Blob | undefined>>(values: T) {
  const data = new FormData();

  for (const key in values) {
    const el = values[key as keyof T];
    if (el) {
      if (typeof el === "number" || typeof el === "boolean") data.append(key, el.toString());
      else {
        data.append(key, el);
      }
    }
  }
  return data;
}
